module.exports = __webpack_public_path__ + "static/media/Satoshi-Medium.cd790237.woff2";